









import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import Alert from '@/components/Shared/Alert.vue';
import ManagementReports from '@/components/Reports/ManagementReports.vue';

@Component({
  name: 'Reports',
  components: { Alert, ManagementReports }
})
export default class extends GiganautVue {

}
